import FixedAssetAPI from './_fixedAssetApi.js';

class FAPurchaseIncrementAPI extends FixedAssetAPI {
  constructor() {
    super();
  }
  controllerName = 'FAPurchaseIncrements';
}

export default new FAPurchaseIncrementAPI();
